import React from 'react';

import { useThemeStatusStore } from 'store/themeStatus.store';

import { MuiIcon } from 'components/common/Icons/base/MuiIcon/MuiIcon';

import classes from 'components/App/AuthenticateLayout/Header/UserMenu/DarkMode/darkMode.module.scss';
import { Switch } from 'components/DesignSystem/Switch';

export const DarkMode = () => {
    const { themeStatus, setThemeStatus } = useThemeStatusStore();
    const handleTheme = () => {
        themeStatus
            ? document.body.setAttribute('data-theme', 'light')
            : document.body.setAttribute('data-theme', 'dark');
        setThemeStatus(!themeStatus);
    };

    return (
        <div className={classes.darkModeContainer}>
            <div className={classes.titleWrapper}>
                <MuiIcon icon={'dark_mode'} fontSize={'2.2rem'} color={'#8c919a'} />
                <span className={classes.title}>Dark Theme</span>
            </div>
            <Switch
                checked={themeStatus}
                onChange={handleTheme}
                onClick={(e: React.MouseEvent) => e.stopPropagation()}
            />
        </div>
    );
};
